var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-row',{staticClass:"template",attrs:{"type":"flex","justify":"center"}},[_c('a-col',{staticClass:"col",attrs:{"span":_vm.grid}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }